import { Button, ButtonBase } from "@mui/material";
import { CaretRightIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import { IconSupport, IconWhatsApp } from "@/components/Icons";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import { WHATSAPP_URL } from "@/utils/constants";

export function MainSearchWhatsAppBanner() {
  const t = useTranslations();

  return (
    <ButtonBase
      onClick={() =>
        rudderAnalytics.track(CommonTrackingEvents.USER_CONTACTED_SUPPORT)
      }
      href={WHATSAPP_URL}
      sx={{
        p: "calc(var(--spacing) * 3)",
        bgcolor: "var(--color-surface-base-light)",
        display: "flex",
        alignItems: "center",
        width: "100%",
        borderRadius: "var(--radius-2xl)",
        border: "1px solid var(--color-stroke-neutral-soft)",
      }}
    >
      <IconSupport className="m-2 me-3 size-8" aria-hidden />

      <span className="flex flex-col text-sm">
        <span className="font-medium text-black">
          {t("support.mainSearch.primaryText")}
        </span>
        <span className="text-text-placeholder">
          {t("support.mainSearch.secondaryText")}
        </span>
      </span>

      <CaretRightIcon
        className="ms-auto size-5 text-text-primary rtl:-scale-x-100"
        aria-hidden
      />
    </ButtonBase>
  );
}

export function SearchResultsWhatsAppBanner() {
  const t = useTranslations();

  return (
    <div className="flex w-full flex-col gap-4 rounded-xl bg-white p-4 shadow-sm">
      <div className="flex items-center">
        <IconSupport className="m-2 me-3 size-9" aria-hidden />

        <span className="flex flex-col text-sm">
          <span className="font-medium text-black">
            {t("support.mainSearch.primaryText")}
          </span>
          <span className="text-text-placeholder">
            {t("support.mainSearch.secondaryText")}
          </span>
        </span>
      </div>

      <Button
        onClick={() => {
          rudderAnalytics.track(CommonTrackingEvents.USER_CONTACTED_SUPPORT);
        }}
        href={WHATSAPP_URL}
        variant="contained"
        color="whatsapp"
        sx={{ borderRadius: "var(--radius-2xl)" }}
        disableElevation
        fullWidth
        startIcon={<IconWhatsApp className="size-5" aria-hidden />}
      >
        {t("support.chatButton")}
      </Button>
    </div>
  );
}
